<div class="{{ product.producto }}" *ngIf="product.producto && product.info">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-modal></app-modal>
    <app-loading></app-loading>
    <app-chat-datina></app-chat-datina>
</div>